import { Menu } from 'lucide-react';
import { useLayout } from '../lib/layout';
import { SIDEBAR_ID } from './Sidebar';

/**
 * Burger that opens the sidebar drawer on mobile. Each page's
 * header should put this first so the drawer trigger is in the
 * same place everywhere (top-left). Hidden on desktop.
 */
export function MobileMenuButton() {
  const { sidebarOpen, openSidebar } = useLayout();
  return (
    <button
      type="button"
      onClick={openSidebar}
      aria-label="Открыть меню"
      aria-expanded={sidebarOpen}
      aria-controls={SIDEBAR_ID}
      className="mc-press inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-foreground active:bg-subtle md:hidden"
    >
      <Menu size={21} strokeWidth={1.8} />
    </button>
  );
}
